// extracted by mini-css-extract-plugin
module.exports = {"tabButtonWrapper":"Tabs_tabButtonWrapper__mLZgL","tabButton":"Tabs_tabButton__qKs2P","active":"Tabs_active__fDJcH"};